import styled from 'styled-components'
import { getTypographyStyles } from '../Typography'

const Link = styled.a<React.HTMLAttributes<HTMLAnchorElement>>`
  transition: color 0.3s ease-out;
  color: var(--brand-primary);
  ${getTypographyStyles('link')}
  font-size: 0.813rem;

  &:hover {
    text-decoration: none;
    color: var(--indigo700);
  }
`

export default Link
